function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M17.362 12.35c-.022-2.435 2.031-3.604 2.124-3.661-1.155-1.655-2.954-1.882-3.595-1.908-1.53-.152-2.986.881-3.761.881-.775 0-1.974-.86-3.242-.835-1.67.024-3.206.949-4.066 2.411-1.732 2.943-.442 7.304 1.245 9.692.826 1.168 1.81 2.483 3.102 2.435 1.246-.049 1.716-.788 3.22-.788 1.503 0 1.927.788 3.243.765 1.339-.026 2.188-1.193 3.008-2.365.946-1.355 1.338-2.667 1.36-2.736-.03-.012-2.61-.98-2.638-3.892zM14.4 5.27c.679-.865 1.137-2.07 1.01-3.27-.977.041-2.16.687-2.863 1.553-.629.765-1.18 1.992-1.03 3.168 1.09.089 2.204-.585 2.883-1.45z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/apple-logo.5325a894.svg";
export { SvgComponent as ReactComponent };